<template>
  <el-dialog title="Déplacement d'une fiche" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <div>
      <p>
        Vous êtes sur le point d'effectuer le déplacement suivant :
      </p>
      <ul>
        <li>Déplacement de la fiche : <customer :item="from"></customer></li>
        <li>Dans la fiche : <customer :item="into"></customer></li>
      </ul>

      <p>Vous pouvez soit : </p>
      <ul>
        <li><strong>Fusionner les fiches</strong> : La fiche déplacée sera supprimée et tout son contenu (rappels,
          commentaires, services etc ...) appartiendra à la fiche de destination.</li>
        <li><strong>Définir comme fiche fille</strong> : La fiche déplacée sera indiquée comme fille de la fiche de
          destination.</li>
      </ul>

      <div style="text-align: center">
        <el-button type="warning" v-on:click="merge()">Fusionner les fiches ...</el-button>
        <el-button type="primary" v-on:click="move()">Définir comme fiche fille</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import Customer from '../Entities/Customer.vue'

  export default {
    components: {
      Customer
    },
    name: 'move-customers-modal',
    data () {
      return {
        visible: false,
        from: null,
        into: null
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this
      this.$model.customer.on('move', ({from, into}) => {
        self.visible = true
        self.from = from
        self.into = into
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
      },
      close () {
        this.visible = false
      },
      merge () {
        this.$model.customer.fire('merge', {
          from: this.from,
          into: this.into
        })
        this.close()
      },
      move () {
        let self = this
        this.$model.customer.api().update(this.from.id, {
          parent_id: self.into.id
        }).then(() => {
          self.close()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MoveCustomersModal.vue?e0d6d674